import type { UseQueryResult } from 'react-query';
import { useQuery } from 'react-query';

import * as insightApi from '@hotjar/webapp/domains/highlights/api';
import type { Highlight } from '@hotjar/webapp/domains/highlights/model';

export function useHighlight(siteId: string, insightId: string): UseQueryResult<Highlight, Error> {
  return useQuery(
    [insightApi.SINGLE_HIGHLIGHT_QUERY_KEY, siteId, insightId],
    () => insightApi.getHighlight(siteId, insightId),
    {
      staleTime: 60 * 1000,
      cacheTime: 60 * 1000,
      refetchOnWindowFocus: false,
    },
  );
}
